module.exports = __webpack_public_path__ + "img/i-icon.64201f44.svg";